import Vuex, { GetterTree, ActionTree, MutationTree, Action } from 'vuex';

interface ICustomerList {
    [key: string]: any;
    loading: boolean;
    infos: Array<{ [key: string]: any }>;
}

export interface IState {
    systemConfigList: ICustomerList;
    classOnLine: {
        [key: string]: any;
        loading: boolean;
        infos: { [key: string]: any }
    };
    docCenter: {
        [key: string]: any;
        loading: boolean;
        infos: { [key: string]: any }
    };
    fileList: ICustomerList;
}

export const state: IState = {
    systemConfigList: {
        loading: false,
        infos: []
    } as ICustomerList,
    classOnLine: {
        loading: false,
        infos: {}
    },
    docCenter: {
        loading: false,
        infos: {}
    } as ICustomerList,
    fileList: {
        loading: false,
        infos: []
    } as ICustomerList
};

// tslint:disable-next-line:ban-types
export const getters: GetterTree<IState, Function> = {
    systemConfigList: (myState: IState) => myState.systemConfigList,
    classOnLine: (myState: IState) => myState.classOnLine,
    docCenter: (myState: IState) => myState.docCenter,
    fileList: (myState: IState) => myState.fileList
};
